import { useState, useEffect } from 'react';

export default function UseFetchPost(url, prams) {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(url, {
      method: 'POST',
      body: prams
    })
      .then((response) => response.json())
      .then((data) => {
        setData(data);
      });
  }, [prams, url]);
  return data;
}
